export const getUserDevice = () => {
    if (navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i)
    ) {
        return 'mobile';
    }

    return 'desktop';
};

export const detectOperatingSystem = (userAgent) => {
    if (userAgent?.includes('Android')) {
        return 'Android';
    }
    if (userAgent?.includes('iPhone') || userAgent?.includes('iPad')) {
        return 'iOS';
    }
    return '';
};

export const DEVICE_TYPE = {
    MOBILE: 'mobile',
    DESKTOP: 'desktop',
};
